<template lang="pug">
    div        
        v-layout(row wrap flat)
            v-flex.mb-2.mt-2(xs12 sm12 md12 align-self-center)
                v-toolbar(:color="colors.info" dark flat height="30")
                    v-toolbar-title VENTA
        v-divider 
        v-layout.pa-3.total(row wrap v-show="posSaleType==2")
            v-flex.xs12.d-flex.justify-space-between
                span TOTAL A PAGAR: 
                span.text-xs-right {{total | mixFormatCurrency}}
        v-layout.pa-3.law(row wrap)
            v-flex.xs12.d-flex.justify-space-between(v-if="showLaw")
                span LEY REDONDEO:
                span.text-xs-right {{roundingLaw | mixFormatCurrency}}
        v-layout.pa-3.total(row wrap)
            v-flex.xs12.d-flex.justify-space-between
                span PAGO CLIENTE:
                span.text-xs-right {{amountPay | mixFormatCurrency}}
        v-layout.pa-3.total(row wrap v-if="!(totalToPay <= 0)")
            v-flex.xs12.d-flex.justify-space-between
                span POR PAGAR:
                span.text-xs-right.red--text {{totalToPay | mixFormatCurrency}}
            //- v-flex(xs9 sm9 md9)
            //-     span.red--text POR PAGAR:  
            //- v-flex(xs3 sm3 md3 color='red darken-1')
            //-     span.red--text {{totalToPay | mixFormatCurrency}}

                            
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils'
export default {
    name: 'sale-information',
    props: {},
    data: function() {
        return {
            dteTypes: [
                { text: 'Boleta E.', value: 1 },
                { text: 'Factura E.', value: 2 },
            ],
            dteSelect: null,
            posSaleType: 2,
        }
    },
    computed: {
        ...mapState('CustomerPaymentModule', {
            iva: 'iva',
            total: 'total',
            net_total: 'net_total',
            arrayPayments: 'arrayPayments',
            lastPaymentMethod: 'lastPaymentMethod',
            paymentMethod: 'paymentMethod',
        }),
        ...mapGetters('CustomerPaymentModule', {
            totalToPay: 'totalToPay',
            totalSale: 'totalSale',
            subTotal: 'subTotal',
            amountDiscount: 'amountDiscount',
            roundingLaw: 'roundingLaw',
        }),

        showLaw: function() {
            let response = this.arrayPayments.find(
                element => element.paymentMethod == 1
            )
            let long = this.arrayPayments.length

            return (response && long == 1 && this.paymentMethod == 1) ||
                (long == 0 && this.paymentMethod == 1)
                ? true
                : false

            //return this.lastPaymentMethod === 1 || this.paymentMethod === 1
            //return true
        },
        amountPay: function() {
            if (this.showLaw) return this.totalSale + this.roundingLaw
            return this.totalSale
        },
    },
    methods: {
        // ...mapActions('CashDeskModule',{
        //     setSaleType :'setSaleType'
        // }),
        // changeDte(idDte){
        //     //alert(idDte+"possaletype"+this.posSaleType)
        //     this.setSaleType(idDte)
        // }
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.addBorder {
    border: solid black 2px;
}
.total {
    font-size: 25px;
    font-weight: bold;
}
.values {
    font-weight: bold;
    font-size: 18px;
}
.labelsInfo {
    font-weight: bold;
}
.law {
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.staffSale {
    font-weight: bold;
    color: red;
}
</style>
